import './fshero.less'

import {Background} from '@codeurs/front'
import React, {HTMLProps} from 'react'
import {ImageOrSvgType, ImageType, LinkType} from 'types'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Countdown, CountdownType} from 'views/layout/countdown'
import {Theme} from 'views/theme'

const styles = style('fshero')

export type FsheroType = {
	image?: ImageType
	image_overlay?: number
	title: string
	subtitle?: string
	date?: string
	location?: string
	button?: LinkType
}

export const Fshero: React.FC<HTMLProps<HTMLDivElement> &
	FsheroType & {
		countdown?: CountdownType
		logos_light?: ImageOrSvgType
	}> = ({
	image,
	image_overlay,
	title,
	subtitle,
	date,
	location,
	button,
	countdown,
	logos_light
}) => {
	const opacity = image_overlay ? image_overlay / 100 : 0
	const fileOrImagePath: (ImageOrSvgType) => string = input =>
		input && (input.src || input.url)

	return (
		<div className={styles()}>
			{image && !image.empty && (
				<>
					<div className={styles('bg')}>
						<Background img={image} />
					</div>
					<span className={styles('overlay')} style={{opacity}} />
				</>
			)}
			{/* <span className={styles('before')} /> */}
			{/* <span className={styles('after')} /> */}
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('content')}>
						{logos_light && (
							<img
								src={fileOrImagePath(logos_light)}
								alt="Logo ITF"
								className={styles('content-logo')}
							/>
						)}
						{title && (
							<div className={styles('content-titlecontainer')}>
								<h1 className={styles('content-title')}>
									<Trusted>{title}</Trusted>
								</h1>
								{/* {subtitle && (
									<Theme.H2 className={styles('content-subtitle')} mod="light">
										{subtitle}
									</Theme.H2>
								)} */}
							</div>
						)}
						{(date || location) && (
							<div className={styles('content-info')}>
								{date && <p className={styles('content-info-date')}>{date}</p>}
								{location && (
									<p className={styles('content-info-location')}>{location}</p>
								)}
							</div>
						)}
						{button && button.url && (
							<Theme.Button
								to={button.url}
								className={styles('content-button')}
								mod={['gradient', 'uppercase']}
							>
								<Theme.ButtonText>
									{button.description || button.title}
								</Theme.ButtonText>
								<Theme.ButtonIcon icon="arrow-long" />
							</Theme.Button>
						)}
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
			<div className={styles('countdown')}>
				<Theme.Container>
					<Countdown {...countdown} />
				</Theme.Container>
			</div>
		</div>
	)
}
